import React from "react";
import PropTypes from "prop-types";
import { fetchAICallJobs } from "actions/ai-call-jobs";
import { killAICallJob } from "actions/company";
import { connect } from "react-redux";
import { selectors } from "reducers";
import { Link } from "react-router-dom";
import moment from "moment";
import useLocalQuery, { Table } from "hooks/useQuery/local-query";

const AICallJobTableRow = ({
  companyGuid,
  companyName,
  threadCount,
  status,
  threadStart,
  jobId,
  threadEnd,
  uniquePatientsContacted,
  errorMessage,
  handleKillAICallJob
}) => (
  <tr className="ai-call-job">
    <td style={{ fontSize: "1.25em" }}>
      <Link to={`/companies/${companyGuid}`}>{companyName}</Link>
    </td>
    <td title={` threadCount: ${threadCount}`} className="ai-call-status">
      {status}
    </td>
    <td>
      {threadStart ? moment(threadStart).format("MMM DD, YYYY hh:mm A") : ""}
    </td>
    <td>{threadEnd ? moment(threadEnd).format("MMM DD, YYYY hh:mm A") : ""}</td>
    <td>{uniquePatientsContacted}</td>
    <td>{jobId}</td>
    <td>
      {errorMessage ? (
        <span style={{ color: "orange" }}>{errorMessage}</span>
      ) : (
        ""
      )}
    </td>
    <td>
      {status != "completed" && (
        <span
          style={{
            color: "red",
            cursor: "pointer",
            textDecoration: "underline"
          }}
          onClick={handleKillAICallJob}
        >
          Kill Job
        </span>
      )}
    </td>
  </tr>
);

const AICallJobManagement = ({
  fetchAICallJobs,
  AICallJobs,
  killAICallJob,
  startDate,
  endDate
}) => {
  const [, setIsFetching] = React.useState(false);
  const requestAICallJobs = React.useCallback(async () => {
    try {
      setIsFetching(true);
      await fetchAICallJobs(startDate, endDate);
    } finally {
      setIsFetching(false);
    }
  }, [fetchAICallJobs, startDate, endDate]);
  React.useEffect(() => {
    requestAICallJobs();
  }, [startDate, endDate]);
  const { rows, query, queryDispatcher } = useLocalQuery(AICallJobs, {
    sort: { by: "threadStart", direction: "desc" },
    filters: { status: ["waiting", "processing", "started"] }
  });
  return (
    <div style={{ paddingBottom: "40px" }}>
      <div className="ai-call-job-managment-container">
        <Table
          query={query}
          queryDispatcher={queryDispatcher}
          rows={rows}
          TableRow={row => (
            <AICallJobTableRow
              {...row}
              handleKillAICallJob={async () => {
                try {
                  await killAICallJob(row.jobId);
                } catch (e) {
                  /* handle error */
                } finally {
                  requestAICallJobs();
                }
              }}
            />
          )}
          rowKey="id"
          columns={[
            {
              field: "companyName",
              header: "Company"
            },
            {
              field: "status",
              header: "Status",
              filters: [
                { value: "completed", text: "Completed" },
                { value: "waiting", text: "Waiting" },
                { value: "started", text: "Started" },
                { value: "processing", text: "Processing" }
              ]
            },
            { field: "threadStart", header: "Start Time" },
            {
              field: "threadEnd",
              header: "End Time"
            },
            {
              field: "uniquePatientsContacted",
              header: "Patients Contacted"
            },
            {
              field: "jobId",
              header: "Thread Name"
            },
            {
              field: "controls",
              header: " "
            }
          ]}
        />
      </div>
    </div>
  );
};

AICallJobTableRow.propTypes = {
  companyName: PropTypes.string.isRequired,
  jobId: PropTypes.string,
  threadCount: PropTypes.number,
  status: PropTypes.string,
  threadStart: PropTypes.string,
  threadEnd: PropTypes.string,
  uniquePatientsContacted: PropTypes.number,
  errorMessage: PropTypes.string,
  companyGuid: PropTypes.string.isRequired,
  handleKillAICallJob: PropTypes.func.isRequired
};

AICallJobManagement.propTypes = {
  AICallJobs: PropTypes.arrayOf(PropTypes.object).isRequired,
  fetchAICallJobs: PropTypes.func.isRequired,
  killAICallJob: PropTypes.func.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired
};

export default connect(
  state => ({
    AICallJobs: selectors.getAICallJobs(state)
  }),
  {
    fetchAICallJobs,
    killAICallJob
  }
)(AICallJobManagement);
